import React, { useState, useEffect } from "react";
import AlertMessage from '../../AlertMessage';

// Dynamically import routes
const categories = {
  Student: [
    "/student-register",
    "/rollNo",
    "/all-student-report",
    "/leaving-certificate",
    "/bonafide",
    "/caste-report",
    "/minority-report",
    "/agewisereport",
    "/IdCard",
    "/generalregister",
    "/stdpersonaldata",
    "/importexport",
    "/shifaras-form",
    "/form-15a",
    "/promote",
  ],

  Result: [
    "/GunaNeendani",
    "/progresssheet",
    "/subjectwise",
    "/collectout",
    "/gradewise",
    "/dailyregister",
    "/boardresult",
    "/Icse",
  ],
  "ICSE Result": [
    "/IcseMarkRegisteration",
    "/IcseResult",
    "/IcseSubjectWise",
    "/IcseGradeWise",
  ],


   "CBSE Result": [
    "/cbsemarkentery",
    "/cbseresult",
    "/cbsehsresult",
    "/preprimary",
    "/cbsesubjectcwise",
  ],

  "Mid day Meal": [
    "/dainandin",
    "/sadhyachasatha",
    "/aavaksatha",
    "/menu",
    "/magani",
    "/praman",
    "/eggandbananaReport",
    "/chavreport",
    "/BMIReport",
    "/certificate",
  ],
  Attendance: ["/PresentySheet", "/PresentyReport"],
  Account: ["/kird"],
  Fee: ["/atm1"],
  "School Details": ["/school-data"],
  // Permission: ["/permissionAccess"],

   Staff: ["/addteacher","/dailyreport","/TIdCard"],

  //  Staff: ["/addteacher", "/attendance-staff-report","/date-of-join-report","/bank-details","/dailyreport","/EditAttendance/:some","/female-staff-report","/male-staff-report","/profile","/salary-details","/shift-time","/teacherinfo","/teacher-info-report","/total-staff-report","/user-permission","/view-attendance/:employeeName","/TIdCard"],

  "Time Table": [
    "/addSubject",
    "/addteacher",
    "/principleform",
    "/teachertimetable",
    "/timetableform",
    "/timetableform1",
    "/weekdayform",
  ],
  
  "Inventory": [
    "/instock",
    "/outstock",
    "/balancestock",
  ],
};

const pagesList = [
  { id: "/home", label: "Home" },
  { id: "/school-data", label: "School Data" },
  { id: "/student-register", label: "New Students" },
  { id: "/all-student-report", label: "Student Report" },
  { id: "/caste-report", label: "Caste Report" },
  { id: "/minority-report", label: "Minority Report" },
  { id: "/agewisereport", label: "Age Report" },
  { id: "/leaving-certificate", label: "Leaving Certificate" },
  { id: "/importexport", label: "Import/Export" },
  { id: "/bonafide", label: "Bonafide" },
  { id: "/IdCard", label: "ID Card" },
  { id: "/generalregister", label: "General Register" },
  { id: "/stdpersonaldata", label: "Student Personal Data" },
  { id: "/shifaras-form", label: "Shifaras Form" },
  { id: "/form-15a", label: "Form 15A" },
  { id: "/promote", label: "Promote Students" },
  { id: "/kird", label: "Account" },
  { id: "/GunaNeendani", label: "Guna Nondani" },
  { id: "/progresssheet", label: "Progress Sheet" },
  { id: "/subjectwise", label: "Subject Wise Report" },
  { id: "/collectout", label: "Collectout" },
  { id: "/gradewise", label: "Grade Wise" },
  { id: "/dailyregister", label: "Daily Register" },
  { id: "/failed", label: "Failed Report" },
  { id: "/boardresult", label: "Board Result" },
  { id: "/rollNo", label: "Roll Number" },
  { id: "/Icse", label: "ICSE" },

  { id: "/IcseMarkRegisteration", label: "ICSE Mark Registration" },
  { id: "/IcseResult", label: "ICSE Result" },
  { id: "/IcseSubjectWise", label: "ICSE SubjectWise Result" },
  { id: "/IcseGradeWise", label: "ICSE Grade Wise Result" },

  
  { id: "/addteacher", label: "Add New Staff" },
  { id: "/dailyreport", label: "Staff Payroll" },
  { id: "/TIdCard", label: "ID Cards" },
  
  { id: "/addSubject", label: "Add Subject" },
  { id: "/addteacher", label: "Add Teachers" },
  { id: "/principleform", label: "All Timetable" },
  { id: "/teachertimetable", label: "Teacher Timetable" },
  { id: "/timetableform", label: "Assign Class-Subject" },
  { id: "/timetableform1", label: "Class Timetable" },
  { id: "/weekdayform", label: "Assign Period" },

  { id: "/instock", label: "Stock Inword" },
  { id: "/outstock", label: "Stock Outword" },
  { id: "/balancestock", label: "Current Stock" },


  { id: "/PresentySheet", label: "Presenty Sheet" },
  { id: "/PresentyReport", label: "Presenty Report" },
  { id: "/sadhyachasatha", label: "Current Stock" },
  { id: "/aavaksatha", label: "Incoming Stock" },
  { id: "/magani", label: "Demand" },
  { id: "/praman", label: "Quantity" },
  { id: "/menu", label: "Menu" },
  { id: "/dainandin", label: "Daily Register" },
  { id: "/dainandinNondreport", label: "Dainandin Report" },
  { id: "/tandalachinondavahi", label: "Tandalachi Nondvahi" },
  { id: "/chavreport", label: "Taste Report" },
  { id: "/BMIReport", label: "BMI Report" },
  { id: "/certificate", label: "Certificate" },
  { id: "/eggandbananaReport", label: "Egg and Banana Report" },
  { id: "/receipt", label: "Receipt" },
  { id: "/atm1", label: "Std Fee" },
  { id: "/paymentint", label: "Payment Integration" },
  { id: "/pavati", label: "Pavati" },
  { id: "/pavatino", label: "Pavati No." },
  { id: "/pavatino1", label: "Pavati No. 1" },
  { id: "/driver", label: "Driver" },
  { id: "/year", label: "Year Pavati" },
  { id: "/update", label: "Updated Report" },
  { id: "/feepavati", label: "Fee Pavati" },
  { id: "/feepavati2", label: "Fee Pavati 2" },
  { id: "/rootpavati", label: "Root Pavati" },
  { id: "/driverpavati", label: "Driver Pavati" },
  { id: "/teacher-LogIn", label: "Teacher Login" },
  { id: "/defaultsetting", label: "Default Settings" },
  { id: "/demo", label: "Demo" },
  { id: "/downloadexe-landingpage", label: "Download EXE Landing Page" },
  { id: "/eguruji-landingpage", label: "eGuruji Landing Page" },


 { id: "/cbsemarkentery", label: "Marks Entry" },
  { id: "/cbseresult", label: "Primary Result" },
  { id: "/cbsehsresult", label: "HSC Result" },
  { id: "/preprimary", label: "Pre-Prmary" },
  { id: "/cbsesubjectcwise", label: "Subject Wise" },



  

];


function PermissionAccess() {
  const [name, setName] = useState("");
  const [mobileNo, setMobileNo] = useState("");
  const [password, setPassword] = useState("");
  const [selectedPages, setSelectedPages] = useState([]);
  const udiseNumber = localStorage.getItem("udiseNumber");
  const [showPassword, setShowPassword] = useState(false);
  // const [expandedMenus, setExpandedMenus] = useState({});
  const [expandedMenus, setExpandedMenus] = useState(
    Object.keys(categories).reduce((acc, category) => {
      acc[category] = false; // Initialize all menus as closed
      return acc;
    }, {})
  );
  const [selectAll, setSelectAll] = useState({});
  const [adminMessage, setAdminMessage] = useState("");

  const adminStatus = "DKglzhgYFYTDT141414HGCkkgfs22117785YFUTFybnujghhgtghghYFYVNOmC234567Omgkysfgvghyfjhyfvv56764"; // Admin status
  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [createdUsers, setCreatedUsers] = useState([]);
  const [editable, setEditable] = useState(false);


  useEffect(() => {
      if (alertMessage) {
        setShowAlert(true);
        const timeoutId = setTimeout(() => {
          setShowAlert(false);
          setAlertMessage(""); 
        }, 3000);
        return () => clearTimeout(timeoutId);
      }
    }, [alertMessage]);
  

    const [language, setLanguage] = useState(localStorage.getItem('language') || 'English');
   useEffect(() => {
      const storedLanguage = localStorage.getItem('language') || 'English';
      setLanguage(storedLanguage);
    }, []);


  // Fetch teacher details when mobileNo changes
  useEffect(() => {
    if (mobileNo.length === 10) {
      fetch(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/user/${mobileNo}.json`)
        .then((response) => response.json())
        .then((data) => {
          if (data) {
            // Check if the udiseNumber in the fetched data matches the localStorage udiseNumber
            if (data.udiseNumber === udiseNumber) {
              // Check if the status matches the admin's status
              if (data.status === adminStatus) {
                setAdminMessage("You are Admin and you have full access.");
                // Clear any other data since it's admin
                setName("");
                setPassword("");
                setSelectedPages([]);
                setEditable(false);
              } else {
                setName(data.name || "");
                setPassword(data.password || "");
                setSelectedPages(data.selectedPages || []);
                setEditable(data.editable || false);
                setAdminMessage(""); // Reset admin message if it's not an admin
              }
            } else {
              // Clear fields if udiseNumber does not match
              setName("");
              setPassword("");
              setSelectedPages([]);
              setEditable(false);
              setAdminMessage(""); // Reset admin message if udiseNumber does not match
              setAlertMessage("The mobile number does not belong to this school.");
            }
          } else {
            // Clear fields if no data found
            setName("");
            setPassword("");
            setSelectedPages([]);
            setEditable(false);
            setAdminMessage(""); // Reset admin message if no data
          }
        })
        .catch((error) => {
          console.error("Error fetching teacher data:", error);
        });
    }
  }, [mobileNo, udiseNumber]);


  const handleMobileNoChange = (e) => {
    const input = e.target.value;
    // Allow only numeric input and limit length to 10
    if (/^\d*$/.test(input) && input.length <= 10) {
      setMobileNo(input);
    }
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    if (mobileNo.length !== 10) {
      setAlertMessage("Please enter a valid 10-digit mobile number.");
      return;
    }

    let superAdminNumber = "";

    try {
      // Fetching superAdmin number (previously 'mobileNumber')
      const superAdminResponse = await fetch(
        `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/schoolData/mobileNumber.json`
      );

      if (superAdminResponse.ok) {
        const superAdminData = await superAdminResponse.json();
        superAdminNumber = superAdminData; // Assuming the value directly represents the number
      } else {
        throw new Error("Unable to fetch super admin number.");
      }
    } catch (error) {
      console.error("Error fetching super admin number:", error);
      setAlertMessage("An error occurred while fetching the super admin number. Please try again.");
      return;
    }

    const data = {
      name,
      superAdminNumber, // Node renamed from 'mobileNumber' to 'superAdminNumber'
      mobileNo, // Store the user's mobile number here
      password,
      selectedPages,
      udiseNumber,
      editable,
      status: "FFJGHKUMGFFJGHUG5376845344DD5435454FF54sdgfasfgasgfssdfbisygfsbsgbkhldfg54574654fgdfsgAFYFGYGHBVFHH54654", // This seems like a placeholder
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/user/${mobileNo}.json`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        }
      );

      if (response.ok) {
        setAlertMessage("Permission access saved successfully!");
        setName("");
        setMobileNo("");
        setPassword("");
        setSelectedPages([]);
        setEditable(false);
      } else {
        setAlertMessage("Failed to save permission access. Please try again.");
      }
    } catch (error) {
      console.error("Error saving permission access:", error);
      setAlertMessage("An error occurred while saving. Please try again.");
    }
  };


  
  const handleSelectAll = (category) => {
    const isAllSelected = !selectAll[category];
    setSelectAll((prev) => ({
      ...prev,
      [category]: isAllSelected,
    }));

    const pageIds = categories[category];
    setSelectedPages((prev) => {
      const updatedSelectedPages = isAllSelected ? [...new Set([...prev, ...pageIds])] : prev.filter(id => !pageIds.includes(id));
      return updatedSelectedPages;
    });
  };

  const handleMenuToggle = (category) => {
    setExpandedMenus((prev) => {
      // Create a new object with all menus closed
      const newExpandedMenus = Object.keys(prev).reduce((acc, key) => {
        acc[key] = false; // Close all menus
        return acc;
      }, {});
  
      // Toggle the clicked menu
      newExpandedMenus[category] = !prev[category];
  
      return newExpandedMenus;
    });
  };

  const handleDeleteUser = async (mobileNoToDelete) => {
  const confirmDelete = window.confirm(
    language === "English"
      ? "Are you sure you want to delete this user?"
      : "तुम्हाला हा वापरकर्ता हटवायचा आहे का?"
  );

  if (!confirmDelete) return;

  try {
    const response = await fetch(
      `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/user/${mobileNoToDelete}.json`,
      {
        method: "DELETE",
      }
    );

    if (response.ok) {
      setAlertMessage("User deleted successfully.");
      // Refresh the user list
      setCreatedUsers((prevUsers) =>
        prevUsers.filter((user) => user.mobileNo !== mobileNoToDelete)
      );
    } else {
      setAlertMessage("Failed to delete user.");
    }
  } catch (error) {
    console.error("Error deleting user:", error);
    setAlertMessage("An error occurred while deleting user.");
  }
};



  useEffect(() => {
  const fetchUsers = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/user.json`);
      const data = await response.json();

      if (data) {
        const filtered = Object.entries(data)
          .map(([key, value]) => ({ mobileNo: key, ...value }))
          .filter(
            (user) =>
              user.udiseNumber === udiseNumber &&
              user.status !== adminStatus // Exclude the admin
          );

        setCreatedUsers(filtered);
      }
    } catch (error) {
      console.error("Error fetching created users:", error);
    }
  };

  fetchUsers();
}, [udiseNumber]);


  const handleCheckboxChange = (pageId) => {
    setSelectedPages((prev) =>
      prev.includes(pageId) ? prev.filter((id) => id !== pageId) : [...prev, pageId]
    );
  };
  return (
    <div className="main-content-of-page" style={{padding: "15px", marginBottom:'40px'}}>
     <AlertMessage message={alertMessage} show={showAlert}/>
      <h4
        style={{
          textAlign: "center",
          marginBottom: "27px",
          color: "#03365e", fontWeight:'600',
          fontFamily: "'Segoe UI', sans-serif", 
        }}
      >

        {language === "English" ? "  Create Teacher Login Permission " : "शिक्षक लॉगिन परवानगी "}
     
      </h4> 
      <form onSubmit={handleSubmit} style={{ 
          justifyContent: 'center', margin:'auto',
          alignItems: 'center', maxWidth:'600px', border:'1px solid #d2c9c9', padding:'35px', borderRadius:'7px'}}>
      {adminMessage && <div style={{ color: "red", textAlign: "center" }}>{adminMessage}</div>}

 <div className="input-group" style={{ marginBottom: "10px" }}>
          <label htmlFor="mobileNo" className="input-label">{language === "English" ? "Mobile Number" : "मोबाईल नंबर"}</label>
          <input
            type="text"
            id="mobileNo"
            value={mobileNo}
            onChange={handleMobileNoChange}
            placeholder= {language === "English" ? "Enter teacher's mobile number" : "शिक्षकाचा मोबाईल नंबर टाका"}
            maxLength={10}
            style={inputStyle}
          />
        </div>


        {/* Name Input */}
        <div className="input-group" style={{ marginBottom: "10px" }}>
          <label htmlFor="name" className="input-label">{language === "English" ? "Name of Teacher" : "शिक्षकाचे नाव"}</label>
          <input
            type="text"
            id="name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder= {language === "English" ? "Enter teacher's username" : "शिक्षकाचे नाव प्रविष्ट करा"}
            style={inputStyle}
          />
        </div>

       

        {/* Password Input */}
        <div className="input-group" style={{ marginBottom: "10px", position: "relative" }}>
          <label htmlFor="password" className="input-label">{language === "English" ? "Create Password" : "पासवर्ड"}</label>
          <input
            type={showPassword ? "text" : "password"}
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder= {language === "English" ? "Enter password" : "पासवर्ड टाका"}
            style={inputStyle}
          />

          
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            style={passwordVisibilityButtonStyle}
          >
            {showPassword ? "🔑" : "👁️"}
          </button>
        </div>

        {/* Editable Checkbox */}
        <div style={{ display: 'flex', alignItems: 'center', marginTop: '15px', marginBottom: '20px', gap: '10px' }}>
          <input
            type="checkbox"
            id="editable"
            checked={editable}
            onChange={(e) => setEditable(e.target.checked)}
            style={{ width: '20px', height: '20px', cursor: 'pointer' }}
          />
          <label htmlFor="editable" style={{ fontSize: '15px', fontWeight: '500', color: '#333', cursor: 'pointer', margin: 0 }}>
            {language === "English" ? "Editable Permission (Allow editing student info on certificates)" : "संपादन परवानगी (प्रमाणपत्रांवर विद्यार्थ्यांची माहिती संपादित करण्याची परवानगी द्या)"}
          </label>
        </div>

        {/* Menu Selection */}
        <div
          style={{
            marginBottom: "30px",
            backgroundColor: "#f9f9f9",
            padding: "20px",
            borderRadius: "8px",
            boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
          }}
        >
          <label
            style={{
              display: "block",
              marginBottom: "15px",
              fontSize: "18px",
              color: "#333",
              textAlign: "center",
              fontWeight: "bold",
            }}
          >
          {language==="English"?"Select Menu Permissions":"मेनू परवानगी निवडा"}
            
          </label>

          {Object.keys(categories).map((category) => (
            <div key={category} style={{ marginBottom: "10px" }}>
              <div
                onClick={() => handleMenuToggle(category)}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  cursor: "pointer",
                  fontWeight: "bold",
                  backgroundColor: "#e3e3e3",
                  padding: "10px",
                  borderRadius: "6px",
                  border: "1px solid #ddd",
                  transition: "background-color 0.3s ease",
                }}
              >
                <span>{category}</span>
                <span
                  style={{
                    fontSize: "18px",
                    transform: expandedMenus[category] ? "rotate(180deg)" : "rotate(0deg)",
                    transition: "transform 0.3s ease",
                  }}
                >
                  &#9660;
                </span>
              </div>

              {expandedMenus[category] && (
                <div style={{ marginLeft: "20px", marginTop: "10px" }}>
                  <div style={{ marginBottom: "10px" , display:'flex'}}>
                    
                  <label style={{width:'300px'}}>Select All</label>
                  <input
                      type="checkbox"
                      checked={selectAll[category] || false}
                      onChange={() => handleSelectAll(category)}
                      style={{ marginLeft: "-110px" , height:'13px', marginTop:'5px' }}
                    />
                   
                  </div>

<hr/>
                  {categories[category].map((pageId) => {
                    const page = pagesList.find((p) => p.id === pageId);
                    return (
                      <>
                      <div key={pageId} style={{ marginBottom: "10px", display:'flex' }}>
                        
                        <label style={{width:'350px'}} htmlFor={pageId}>{page ? page.label : pageId}</label>
                        <input
                          type="checkbox"
                          id={pageId}
                          checked={selectedPages.includes(pageId)}
                          onChange={() => handleCheckboxChange(pageId)}
                          style={{ marginLeft: "-150px", height:'13px', marginTop:'5px' }}
                        />
                      
                      </div>
                      <hr/>
                      </>
                    );
                  })}
                </div>
              )}
            </div>
          ))}
        </div>
<div style={{textAlign:'center'}}>
       <button
  type="submit"
  disabled={adminMessage !== ""}
  style={{
    width: "100px",
    padding: "7px",
    backgroundColor: adminMessage ? "gray" : "green",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    fontSize: "16px",
    cursor: adminMessage ? "not-allowed" : "pointer",
    transition: "background-color 0.3s ease"
  }}
>
  Submit
</button>

        </div>
      </form>
     {createdUsers.length > 0 && (
  <div style={{ maxWidth: "800px", margin: "40px auto" }}>
    <h4 style={{ textAlign: "center", marginBottom: "20px", color: "#03365e" }}>
      {language === "English" ? "Users Created by Admin" : "प्रशासकांनी तयार केलेले वापरकर्ते"}
    </h4>
    <table style={{ width: "100%", borderCollapse: "collapse" }}>
      <thead>
        <tr style={{ backgroundColor: "#f0f0f0" }}>
          <th style={thStyle}>Sr No.</th>
          <th style={thStyle}>{language === "English" ? "Mobile No" : "मोबाईल नं."}</th>
          <th style={thStyle}>{language === "English" ? "Name" : "नाव"}</th>
          <th style={thStyle}>{language === "English" ? "Access Count" : "परवानग्या संख्या"}</th>
          <th style={thStyle}>{language === "English" ? "Romove Access" : "परवानग्या रद्द"}</th>

        </tr>
      </thead>
      <tbody>
        {createdUsers.map((user, index) => (
         <tr key={user.mobileNo}>
  <td style={tdStyle}>{index + 1}</td>
  <td style={tdStyle}>{user.mobileNo}</td>
  <td style={tdStyle}>{user.name}</td>
  <td style={tdStyle}>{user.selectedPages?.length || 0}</td>
  <td style={tdStyle}>
    <button
      onClick={() => handleDeleteUser(user.mobileNo)}
      style={{
        backgroundColor: "red",
        color: "#fff",
        border: "none",
        padding: "5px 10px",
        borderRadius: "4px",
        cursor: "pointer",
      }}
    >
      Delete
    </button>
  </td>
</tr>
        ))}
      </tbody>
    </table>
  </div>
)}


    </div>
  );
}

const thStyle = {
  padding: "10px",
  border: "1px solid #ccc",
  textAlign: "left",
};

const tdStyle = {
  padding: "10px",
  border: "1px solid #ccc",
};


const inputStyle = {
  width: "100%",
  padding: "6px",
  border: "1px solid #ccc",
  borderRadius: "6px",
  fontSize: "16px",
  marginTop: "5px",
  marginBottom: "5px",
};

const passwordVisibilityButtonStyle = {
  position: "absolute",
  right: "10px",
  top: "50%",
  transform: "translateY(-50%)",
  background: "none",
  border: "none",
  cursor: "pointer",
  fontSize: "16px",
  marginTop:'10px'
};
export default PermissionAccess;
